import type { PortfolioPageView } from "./_types";
import logEvent from "./logEvent";
import type { LoggingEvent } from './logEvent'

/**
 *
 * @param props This object contains
 */

const portfolioPageView = ({ portfolio_id }: PortfolioPageView) => {
  // UA
  // This is handled by the default pageView

  // Tag Manager
  let layerUpdate: LoggingEvent = { event: "portfolio_page_view" };

  if (portfolio_id) layerUpdate.portfolio_id = portfolio_id;

  logEvent(layerUpdate)
};

export default portfolioPageView;
